module.exports = __webpack_public_path__ + "static/media/19ESCAP16.0fa31734.jpg";